import type { Config } from 'tailwindcss';

export default {
  content: ['./app/**/{**,.client,.server}/**/*.{js,jsx,ts,tsx}'],
  theme: {
    // We keep the breakpoints here so they can be used in useIsMobile
    screens: {
      xs: '480px',
      sm: '640px',
      md: '824px',
      lg: '1024px',
      xl: '1280px',
      '2xl': '1536px'
    }
  },
  plugins: [
    function ({
      addVariant
    }: {
      addVariant: (name: string, rules: string) => void;
    }) {
      addVariant('standalone', '@media all and (display-mode: standalone)');
    }
  ]
} satisfies Config;
